<div class="sales-opportunity-box-container">
    <div>
        <div class="dollar-value title">
            ${{displayDollarValue() | abbreviateNumber}}
        </div>
        <div class="heading-group">
            <span class="opportunity-text title">
                Est. Sales Opportunity
            </span>
            <span class="opportunity-text title">
                ({{currPageState}})
            </span>
        </div>
    </div>
</div>